// export default {
//   designation: "",
//   company: "",
//   experience: "",
//   description: "",
//   startDate: undefined,
//   endDate: undefined,
// };
// const state = {
//   allExp: [],
// };
// export default state;

export default {
  allExp: [],
};
